export enum PermissionAction {
    VIEW = 'view',
    CREATE = 'create',
    EDIT = 'edit',
    DELETE = 'delete',
    IMPORT = 'import',
    EXPORT = 'export',
}

export enum ModulePermission {
    USERS = 'USERS',
    LEADS = 'LEADS',
    ORDERS = 'ORDERS',
    TRADING = 'TRADING',
    CUSTOMERS = 'CUSTOMERS',
    ASSETS = 'ASSETS',
    INSTRUMENTS = 'INSTRUMENTS',
    TRADES = 'TRADES',
    KYC = 'KYC',
    TRANSACTIONS = 'TRANSACTIONS',
    SYSTEM_SETTINGS = 'SYSTEM_SETTINGS',
    AUDIT_LOG = 'AUDIT_LOG',
    ROLES = 'ROLES',
    TRADING_ACCOUNTS = 'TRADING_ACCOUNTS',
    PAYMENT_METHODS = 'PAYMENT_METHODS',
    NOTES = 'NOTES',
    NOTIFICATIONS = 'NOTIFICATIONS',
    INTEGRATIONS = 'INTEGRATIONS',
    CAMPAIGNS = 'CAMPAIGNS',
}

// Helper functions
export const getPermissionActionDisplayName = (action: PermissionAction): string => {
    const displayNames = {
        [PermissionAction.VIEW]: 'View',
        [PermissionAction.CREATE]: 'Create',
        [PermissionAction.EDIT]: 'Edit',
        [PermissionAction.DELETE]: 'Delete',
        [PermissionAction.IMPORT]: 'Import',
        [PermissionAction.EXPORT]: 'Export',
    };
    return displayNames[action];
};

export const getModuleDisplayName = (module: ModulePermission): string => {
    const displayNames = {
        [ModulePermission.USERS]: 'Users',
        [ModulePermission.LEADS]: 'Leads',
        [ModulePermission.ORDERS]: 'Orders',
        [ModulePermission.TRADING]: 'Trading',
        [ModulePermission.CUSTOMERS]: 'Customers',
        [ModulePermission.ASSETS]: 'Assets',
        [ModulePermission.INSTRUMENTS]: 'Instruments',
        [ModulePermission.TRADES]: 'Trades',
        [ModulePermission.KYC]: 'KYC',
        [ModulePermission.TRANSACTIONS]: 'Transactions',
        [ModulePermission.SYSTEM_SETTINGS]: 'System Settings',
        [ModulePermission.AUDIT_LOG]: 'Audit Log',
        [ModulePermission.ROLES]: 'Roles',
        [ModulePermission.TRADING_ACCOUNTS]: 'Trading Accounts',
        [ModulePermission.PAYMENT_METHODS]: 'Payment Methods',
        [ModulePermission.NOTES]: 'Notes',
        [ModulePermission.NOTIFICATIONS]: 'Notifications',
        [ModulePermission.INTEGRATIONS]: 'Integrations',
        [ModulePermission.CAMPAIGNS]: 'Campaigns',
    };
    return displayNames[module];
};

// Type definitions
export type UserPermissions = {
    [module in ModulePermission]: {
        [action in PermissionAction]: boolean;
    };
};
